import { DashboardSdk } from '@bringg/frontend-utils';

function getRegion(dashboardSdk: DashboardSdk) {
  const { region } = dashboardSdk.sdk.session.user;

  return getConfig(dashboardSdk).regions[region];
}

function getConfig(dashboardSdk: any) {
  return dashboardSdk.config;
}

export function getServiceApiEndpoint(dashboardSdk: DashboardSdk): string {
  return getRegion(dashboardSdk).services_end_point;
}

export function getAdminApiEndpoint(dashboardSdk: DashboardSdk): string {
  return getRegion(dashboardSdk).web_api_url;
}

export function getWebUrl(dashboardSdk: DashboardSdk): string {
  return getRegion(dashboardSdk).web_app_url;
}
